import type OriginTracer from '@atlassiansox/origin-tracing';

import type { AnyAri } from '@atlassian/ari';

import type { Product } from '../common/common';

const getInstanceUrl = (): string => {
	return window.location.origin;
};

const landingPathMap: Partial<Record<Product, string>> = {
	confluence: '/wiki',
	compass: '/compass',
	avp: '/analytics',
	mercury: '/focus',
};

const getLandingPathByProduct = (product: Product): string => landingPathMap[product] ?? '';

export const getContinueUrlWithOrigin = (
	continueUrl: string | undefined,
	resources: AnyAri[],
	origin: OriginTracer,
): string => {
	const instanceUrl = getInstanceUrl();
	let productContinueUrl = continueUrl;
	const targetProducts = resources.map((resource) => resource.resourceOwner as Product);

	if (continueUrl && origin.containsOrigin(continueUrl)) {
		throw new Error('continueUrl contains Origin Tracing query parameter');
	}

	if (!productContinueUrl) {
		productContinueUrl =
			resources.length === 1
				? `${instanceUrl}${getLandingPathByProduct(targetProducts[0])}`
				: instanceUrl;
	}

	// Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
	// We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
	if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) {
		productContinueUrl =
			targetProducts.length === 1
				? `${instanceUrl}${getLandingPathByProduct(targetProducts[0])}`
				: instanceUrl;
	}

	return origin.addToUrl(productContinueUrl);
};
